import * as React from 'react';
import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox';
import { FMIcon } from 'atoms';

export default (props: CheckboxProps) => (
    <Checkbox
        checkedIcon={<FMIcon type="collapse" color="primary" />}
        icon={<FMIcon type="expand" color="primary" />}
        {...props}
    />
);
